var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-dialog" }, [
    _c(
      "div",
      { staticClass: "modal-content", staticStyle: { width: "600px" } },
      [
        _c("div", { staticClass: "modal-header" }, [
          _c("h5", { staticClass: "modal-title" }, [
            _vm._v(_vm._s(_vm.$t("sdl.gcrm.breadcrumb.notice.list")))
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "close",
              attrs: {
                type: "button",
                "data-dismiss": "modal",
                "aria-label": "Close"
              },
              on: {
                click: function($event) {
                  return _vm.$emit("close")
                }
              }
            },
            [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
          )
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "modal-footer" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-secondary",
              attrs: { type: "button", "data-dismiss": "modal" },
              on: {
                click: function($event) {
                  return _vm.$emit("close")
                }
              }
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("sdl.common.label.close")) +
                  "\n        "
              )
            ]
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-body" }, [
      _vm._v("\n        개인정보 조회 가능 시스템에 대한 보안 강화에 따라, "),
      _c("br"),
      _vm._v(
        "\n\n한국총괄 GCRM 시스템 (Loyalty Korea) 은 Knox 퀵링크를 통한 접속만 허용될 예정입니다."
      ),
      _c("br"),
      _vm._v(
        "\n\n아래 변경사항 및 적용 일시 참고하여 주시고, 문의사항이 있으시면 담당자 연락 부탁 드립니다."
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _c("br"),
      _vm._v("\n\n□ 변경사항 : 한국총괄 GCRM 시스템 접속 방법 변경\n"),
      _c("br"),
      _vm._v(
        "\n    - As-is : ①Knox 퀵링크 및 ②GCRM 포털에서 Loyalty Korea 시스템 클릭시 접속 가능\n    "
      ),
      _c("br"),
      _vm._v(
        "\n    - To-be : ①Knox 퀵링크 로만 접속 가능 (포털에서 Loyalty Korea 링크 히든 예정)\n\n    "
      ),
      _c("br"),
      _vm._v(" "),
      _c("br"),
      _vm._v("\n\n□ 변경시점 : 3/20 (월) ~\n"),
      _c("br"),
      _vm._v("\n※ 담당자 : 심미소프로 (miso.sim@samsung.com)\n\n    ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15e21838", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15e21838","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/admin/main/PopupLoyaltyKorea.vue
// module id = null
// module chunks = 